import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../images/circle-info-regular-full.svg'

function KeywordFeature ({ localFeatureKeyword, setLocalFeatureKeyword }) {
  const handleKeywordChange = e => {
    const { id, value } = e.target
    setLocalFeatureKeyword(prev => ({
      ...prev,
      [id]: value
    }))
  }

  return (
    <section className={styles.keywordFeatureSection}>
      <h1 className={styles.keywordFeatureTitle}>Keyword search</h1>

      <div className={styles.keywordFeatureContainer}>
        <div className={styles.keywordFeatureColumn}>
          <div className={styles.inlineLabel}>
            <label className={styles.FeatureKeywordLabel} htmlFor='key'>
              Feature key
            </label>
            <Tooltip
              title="The attribute name you want to filter by."
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Feature key help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            placeholder='Key'
            className={styles.FeatureKeywordInput}
            type='text'
            autoComplete='off'
            id='key'
            value={localFeatureKeyword.key}
            onChange={handleKeywordChange}
          />
        </div>
        <div className={styles.keywordFeatureColumn}>
          <div className={styles.inlineLabel}>
            <label className={styles.FeatureKeywordLabel} htmlFor='value'>
              Feature value
            </label>
            <Tooltip
              title="The attribute value you want to match"
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Feature value help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            placeholder='Value'
            className={styles.FeatureKeywordInput}
            type='text'
            autoComplete='off'
            id='value'
            value={localFeatureKeyword.value}
            onChange={handleKeywordChange}
          />
        </div>
      </div>
    </section>
  )
}

export default KeywordFeature
